module.exports = __webpack_public_path__ + "static/media/road-assistance-logo.d00a0032.svg";